var parent = require('../../es/object/keys');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/object/keys.js
// module id = 1021
// module chunks = 0